import { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Tooltip,
  IconButton,
  InputBase,
  Button,
  Avatar,
  Dialog,
  DialogContent,
  TextField,
  DialogActions,
  Typography,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseUser } from "./UseUser";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import DeleteRow from "../../components/DeleteRow";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";

export default function Users() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [state, setState] = useState();
  const navigate = useNavigate();
  const { getUserList, deleteUser, addUser } = UseUser();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [userRes, setUserRes] = useState();
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getUserList(
      myPc,
      search,
      (users) => {
        if (msGotoLast) {
          setMsGotoLast(false);
          goToLastPage(users.totalPage);
          return;
        }
        setUserRes(users);
      },
      true
    );
  }, [myPc]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const newFunc = () => {
    return setOpen(true);
  };

  const columns = [
    {
      field: "avatarName",
      headerName: "آواتار",
      width: 100,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return <Avatar src={cellValues.value} />;
      },
    },
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "firstName",
      headerName: "نام",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.firstName}
          </Typography>
        );
      },
    },
    {
      field: "lastName",
      headerName: "نام خانوادگی",
      width: 150,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.lastName}
          </Typography>
        );
      },
    },
    {
      field: "mobile",
      headerName: "شماره موبایل",
      width: 130,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "perfix",
      headerName: "سمت",
      width: 150,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "عملیات",
      sortable: false,
      width: 100,
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box>
            <Tooltip title="Delete">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name:
                      cellValues.row.firstName + " " + cellValues.row.lastName,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit">
              <IconButton
                onClick={() => {
                  setScrollTo(cellValues.api.getScrollPosition());

                  return navigate("/users/edituser", {
                    state: {
                      model: cellValues.row,
                      myPc: myPc,
                      search: search,
                      id: cellValues.row.id,
                    },
                  });
                }}
              >
                <EditIcon sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "search",
      width: 200,
      sortable: false,
      headerAlign: "center",
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "کاربران",
        childs: [{ name: msActiveMenu.pageTitle, url: "/users" }],
      }}
    >
      {userRes ? (
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={userRes.pageCondition.pageCount}
          rows={userRes.users}
          paginationMode="server"
          page={userRes.pageCondition.page - 1}
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={
            userRes?.pageCondition.totalItemCount
              ? userRes.pageCondition.totalItemCount
              : 1
          }
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              scrollTo: myPc.scrollTo,
              newFunc: newFunc,
              isLtr: true,
              rowCount: userRes?.pageCondition.totalItemCount
                ? userRes.pageCondition.totalItemCount
                : "",
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPc.sortColumn),
                  sort: deCapitalizeFirstLetter(myPc.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPc.page,
            },
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"کاربر"}
        callback={() => {
          setProgress(true);
          deleteUser(deleteState.id, () => {
            refresh();
          });
        }}
      ></DeleteRow>
      <Dialog
        open={open}
        maxWidth="xs"
        fullWidth
        sx={{
          "& .MuiPaper-root ": {
            height: "30",
          },
        }}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <TextField
            size="small"
            autoFocus
            id="outlined-basic"
            value={state ? state : ""}
            label="شماره همراه را وارد کنید :"
            fullWidth
            variant="outlined"
            onChange={(event) => setState(event.target.value)}
          />
        </DialogContent>
        <DialogActions sx={{ m: 2 }}>
          <Button
            size="small"
            variant="contained"
            onClick={() => {
              setProgress(true);
              addUser(state, () => {
                getUserList(
                  myPc,
                  search,
                  (users) => {
                    setUserRes(users);
                  },
                  true
                );
                setState("");
                setOpen(false);
              });
            }}
          >
            اضافه کردن
          </Button>
          <Button
            size="small"
            variant="outlined"
            color="secondary"
            onClick={() => {
              setState("");
              setOpen(false);
            }}
          >
            انصراف
          </Button>
        </DialogActions>
      </Dialog>
    </Detail>
  );
}
